<template>
    <EditModal
        v-model:open="isVisible"
        :title="editingStepId ? '編輯步驟' : '新增步驟'"
        :confirm-loading="confirmLoading"
        :width="1000"
        @ok="handleSubmit"
        @cancel="handleCancel"
    >
        <template #form>
            <a-form
                ref="formRef"
                :model="formData"
                :rules="formRules"
                autocomplete="off"
                layout="vertical"
            >
                <a-collapse
                    v-model:activeKey="sectionsActiveKeys"
                    :bordered="false"
                    class="form-sections-collapse"
                >
                    <!-- 基本資訊區塊 -->
                    <a-collapse-panel key="basic" class="form-section-panel">
                        <template #header>
                            <span class="section-header">基本資訊</span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-row :gutter="16">
                                <!-- 左側：基本資料與狀態設定 -->
                                <a-col :span="12">
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item
                                                label="名稱"
                                                name="name"
                                            >
                                                <a-input
                                                    v-model:value="
                                                        formData.name
                                                    "
                                                    placeholder="請輸入名稱"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item
                                                label="屬性"
                                                name="attribute"
                                            >
                                                <a-select
                                                    v-model:value="
                                                        formData.attribute
                                                    "
                                                    placeholder="請選擇屬性"
                                                >
                                                    <a-select-option
                                                        v-for="attr in missionOptions.attributes"
                                                        :key="attr.value"
                                                        :value="attr.value"
                                                    >
                                                        {{ attr.label }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-form-item
                                        label="描述"
                                        name="description"
                                    >
                                        <a-textarea
                                            v-model:value="formData.description"
                                            :rows="3"
                                            placeholder="請輸入描述"
                                        />
                                    </a-form-item>
                                    <a-row
                                        :gutter="16"
                                        class="form-row-compact"
                                    >
                                        <a-col :span="12">
                                            <a-form-item label="狀態">
                                                <a-select
                                                    v-model:value="
                                                        formData.is_active
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        啟用
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        停用
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="必須完成">
                                                <a-select
                                                    v-model:value="
                                                        formData.is_required
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        是
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        否
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-row
                                        :gutter="16"
                                        class="form-row-compact"
                                    >
                                        <a-col :span="24">
                                            <a-form-item
                                                name="unlock_from_node_id"
                                            >
                                                <template #label>
                                                    前置任務
                                                </template>
                                                <input
                                                    type="text"
                                                    :id="`task-unlock-from-node-${formData.id || 'new'}`"
                                                    :value="
                                                        formData.unlock_from_node_id
                                                    "
                                                    readonly
                                                    tabindex="-1"
                                                    style="
                                                        position: absolute;
                                                        opacity: 0;
                                                        pointer-events: none;
                                                        width: 0;
                                                        height: 0;
                                                    "
                                                />
                                                <div
                                                    v-if="
                                                        formData.unlock_from_node_id
                                                    "
                                                    class="node-selector-display"
                                                    @click="
                                                        () =>
                                                            $emit(
                                                                'open-node-selector',
                                                                'unlock-source',
                                                                false,
                                                                formData
                                                            )
                                                    "
                                                >
                                                    <a-tag
                                                        closable
                                                        @close.stop="
                                                            (e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                formData.unlock_from_node_id =
                                                                    undefined;
                                                            }
                                                        "
                                                        color="green"
                                                        class="node-tag"
                                                    >
                                                        {{
                                                            formData.unlock_from_node_name ||
                                                            unlockFromNodeLabel ||
                                                            getNodeName(
                                                                formData.unlock_from_node_id
                                                            ) ||
                                                            formData.unlock_from_node_id
                                                        }}
                                                    </a-tag>
                                                </div>
                                                <a-button
                                                    v-else
                                                    type="dashed"
                                                    @click="
                                                        () =>
                                                            $emit(
                                                                'open-node-selector',
                                                                'unlock-source',
                                                                false,
                                                                formData
                                                            )
                                                    "
                                                    class="node-selector-btn"
                                                >
                                                    選擇前置任務
                                                </a-button>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-row
                                        :gutter="16"
                                        class="form-row-compact"
                                    >
                                        <a-col :span="24">
                                            <a-form-item label="可重複執行">
                                                <a-select
                                                    v-model:value="
                                                        formData.is_repeatable
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        是
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        否
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-row
                                        v-if="formData.is_repeatable"
                                        :gutter="16"
                                        class="form-row-compact"
                                    >
                                        <a-col :span="12">
                                            <a-form-item
                                                label="重複週期"
                                                name="repeat_cycle"
                                            >
                                                <a-select
                                                    v-model:value="
                                                        formData.repeat_cycle
                                                    "
                                                    placeholder="請選擇重複週期"
                                                    :options="
                                                        (
                                                            missionOptions.repeatCycles ||
                                                            []
                                                        ).map((cycle) => ({
                                                            label: cycle.label,
                                                            value: cycle.value
                                                        }))
                                                    "
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item
                                                label="每週期最大次數"
                                                name="max_times_per_cycle"
                                            >
                                                <a-input-number
                                                    v-model:value="
                                                        formData.max_times_per_cycle
                                                    "
                                                    placeholder="每週期最大次數"
                                                    style="width: 100%"
                                                    :min="1"
                                                />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-col>
                                <!-- 右側：時間設定與觸發任務 -->
                                <a-col :span="12">
                                    <a-form-item
                                        label="開始時間"
                                        name="start_time"
                                    >
                                        <a-date-picker
                                            v-model:value="formData.start_time"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            placeholder="請選擇開始時間（選填）"
                                            style="width: 100%"
                                            @change="
                                                (d) => {
                                                    formData.start_time =
                                                        applyStartOfDay(d);
                                                }
                                            "
                                        />
                                    </a-form-item>
                                    <a-form-item
                                        label="結束時間"
                                        name="end_time"
                                    >
                                        <a-date-picker
                                            v-model:value="formData.end_time"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            placeholder="請選擇結束時間（選填）"
                                            style="width: 100%"
                                            @change="
                                                (d) => {
                                                    formData.end_time =
                                                        applyEndOfDay(d);
                                                }
                                            "
                                        />
                                    </a-form-item>
                                    <a-form-item name="trigger_node_ids">
                                        <template #label>完成後觸發</template>
                                        <input
                                            type="text"
                                            :id="`task-trigger-nodes-${formData.id || 'new'}`"
                                            :value="
                                                formData.trigger_node_ids?.join(
                                                    ','
                                                ) || ''
                                            "
                                            readonly
                                            tabindex="-1"
                                            style="
                                                position: absolute;
                                                opacity: 0;
                                                pointer-events: none;
                                                width: 0;
                                                height: 0;
                                            "
                                        />
                                        <div
                                            v-if="
                                                formData.trigger_node_ids &&
                                                formData.trigger_node_ids
                                                    .length > 0
                                            "
                                            class="node-selector-display multiple"
                                            @click="
                                                () =>
                                                    $emit(
                                                        'open-node-selector',
                                                        'unlock',
                                                        true,
                                                        formData
                                                    )
                                            "
                                        >
                                            <a-tag
                                                v-for="(
                                                    nodeId, index
                                                ) in formData.trigger_node_ids"
                                                :key="index"
                                                closable
                                                @close.stop="
                                                    (e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        formData.trigger_node_ids.splice(
                                                            index,
                                                            1
                                                        );
                                                    }
                                                "
                                                color="blue"
                                                class="node-tag"
                                            >
                                                {{
                                                    formData.trigger_node_names[
                                                        nodeId
                                                    ] ||
                                                    getNodeName(nodeId) ||
                                                    nodeId
                                                }}
                                            </a-tag>
                                        </div>
                                        <a-button
                                            v-else
                                            type="dashed"
                                            @click="
                                                () =>
                                                    $emit(
                                                        'open-node-selector',
                                                        'unlock',
                                                        true,
                                                        formData
                                                    )
                                            "
                                            class="node-selector-btn"
                                        >
                                            選擇觸發任務
                                        </a-button>
                                    </a-form-item>
                                    <a-row
                                        :gutter="16"
                                        class="form-row-compact"
                                    >
                                        <a-col :span="12">
                                            <a-form-item label="等待觸發">
                                                <a-select
                                                    v-model:value="
                                                        formData.is_trigger
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        是
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        否
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item
                                                v-if="formData.is_trigger"
                                                label="被哪個任務觸發"
                                                name="triggered_by_id"
                                            >
                                                <div
                                                    v-if="
                                                        formData.triggered_by_id
                                                    "
                                                    class="node-selector-display"
                                                    @click="
                                                        () =>
                                                            $emit(
                                                                'open-node-selector',
                                                                'trigger',
                                                                false,
                                                                formData
                                                            )
                                                    "
                                                >
                                                    <a-tag
                                                        closable
                                                        @close.stop="
                                                            (e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                formData.triggered_by_id =
                                                                    undefined;
                                                            }
                                                        "
                                                        color="purple"
                                                        class="node-tag"
                                                    >
                                                        {{
                                                            triggeredByNodeLabel ||
                                                            getNodeName(
                                                                formData.triggered_by_id
                                                            ) ||
                                                            formData.triggered_by_id
                                                        }}
                                                    </a-tag>
                                                </div>
                                                <a-button
                                                    v-else
                                                    type="dashed"
                                                    @click="
                                                        () =>
                                                            $emit(
                                                                'open-node-selector',
                                                                'trigger',
                                                                false,
                                                                formData
                                                            )
                                                    "
                                                    class="node-selector-btn"
                                                >
                                                    選擇觸發此任務的任務
                                                </a-button>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-row
                                        v-if="formData.is_trigger"
                                        :gutter="16"
                                    >
                                        <a-col :span="24">
                                            <a-form-item
                                                label="協作角色或單位"
                                                name="designated_collaborator"
                                            >
                                                <a-select
                                                    v-model:value="
                                                        formData.designated_collaborator
                                                    "
                                                    mode="multiple"
                                                    placeholder="請選擇協作角色或單位（可多選）"
                                                    allow-clear
                                                    style="width: 100%"
                                                    :virtual="false"
                                                >
                                                    <a-select-option
                                                        v-for="collaborator in missionOptions.collaboratorTypes"
                                                        :key="
                                                            collaborator.value
                                                        "
                                                        :value="
                                                            collaborator.value
                                                        "
                                                    >
                                                        {{ collaborator.label }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-row
                                        v-if="
                                            formData.is_trigger &&
                                            formData.designated_collaborator &&
                                            formData.designated_collaborator
                                                .length > 0
                                        "
                                        :gutter="16"
                                    >
                                        <a-col :span="24">
                                            <a-form-item
                                                label="過期失效"
                                                name="pass_through"
                                            >
                                                <a-select
                                                    v-model:value="
                                                        formData.pass_through
                                                    "
                                                    style="width: 100%"
                                                    @change="
                                                        () => {
                                                            formRef.value?.validateFields(
                                                                ['pass_through']
                                                            );
                                                        }
                                                    "
                                                >
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        否
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        是
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 可見性規則區塊 -->
                    <a-collapse-panel
                        key="visibility"
                        class="form-section-panel"
                    >
                        <template #header>
                            <span class="section-header">
                                誰可以看到
                                <span class="section-note">
                                    （如果沒有設定則無限制）
                                </span>
                            </span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rules-section">
                                    <div class="rules-header">
                                        <a-button
                                            type="dashed"
                                            @click="addVisibilityRule"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增誰可以看到設定
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.visibility_rules &&
                                            formData.visibility_rules.length > 0
                                        "
                                        class="rules-list"
                                    >
                                        <div
                                            v-for="(
                                                rule, index
                                            ) in formData.visibility_rules"
                                            :key="index"
                                            class="rule-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="10">
                                                    <a-select
                                                        v-model:value="
                                                            rule.audience_type
                                                        "
                                                        placeholder="選擇誰可以看到"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'visibility',
                                                                    index
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.visibility_audience_types"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <a-select
                                                        v-if="
                                                            (
                                                                getVisibilityTypeOptions(
                                                                    rule.audience_type
                                                                ) || []
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        :placeholder="
                                                            getVisibilityPlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        <a-select-option
                                                            v-for="opt in getVisibilityTypeOptions(
                                                                rule.audience_type
                                                            )"
                                                            :key="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value
                                                            "
                                                            :value="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value ||
                                                                opt.name
                                                            "
                                                        >
                                                            {{
                                                                opt.label ||
                                                                opt.name
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <a-select
                                                        v-else-if="
                                                            rule.audience_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員名稱（可多選）"
                                                        style="width: 100%"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'visibility',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    ></a-select>
                                                    <a-input
                                                        v-else
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        :placeholder="
                                                            getVisibilityInputPlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col :span="2">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeVisibilityRule(
                                                                index
                                                            )
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rules">
                                        <a-empty
                                            description="尚未設定誰可以看到"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 可執行規則區塊 -->
                    <a-collapse-panel
                        key="executable"
                        class="form-section-panel"
                    >
                        <template #header>
                            <span class="section-header">
                                誰可以執行
                                <span class="section-note">
                                    （如果沒有設定則無限制）
                                </span>
                            </span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rules-section">
                                    <div class="rules-header">
                                        <a-button
                                            type="dashed"
                                            @click="addExecutableRule"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增誰可以執行設定
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.executable_rules &&
                                            formData.executable_rules.length > 0
                                        "
                                        class="rules-list"
                                    >
                                        <div
                                            v-for="(
                                                rule, index
                                            ) in formData.executable_rules"
                                            :key="index"
                                            class="rule-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="10">
                                                    <a-select
                                                        v-model:value="
                                                            rule.actor_type
                                                        "
                                                        placeholder="選擇誰可以執行"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'executable',
                                                                    index
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.executable_actor_types"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <a-select
                                                        v-if="
                                                            (
                                                                getExecutableTypeOptions(
                                                                    rule.actor_type
                                                                ) || []
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        mode="multiple"
                                                        :placeholder="
                                                            getExecutablePlaceholder(
                                                                rule.actor_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        <a-select-option
                                                            v-for="opt in getExecutableTypeOptions(
                                                                rule.actor_type
                                                            )"
                                                            :key="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value
                                                            "
                                                            :value="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value ||
                                                                opt.name
                                                            "
                                                        >
                                                            {{
                                                                opt.label ||
                                                                opt.name
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <a-select
                                                        v-else-if="
                                                            rule.actor_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'executable',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'executable',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員名稱（可多選）"
                                                        style="width: 100%"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'executable',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    ></a-select>
                                                    <a-input
                                                        v-else
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        :placeholder="
                                                            getExecutableInputPlaceholder(
                                                                rule.actor_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col :span="2">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeExecutableRule(
                                                                index
                                                            )
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rules">
                                        <a-empty
                                            description="尚未設定誰可以執行"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 條件設定區塊 -->
                    <a-collapse-panel
                        key="conditions"
                        class="form-section-panel"
                    >
                        <template #header>
                            <span class="section-header">條件設定</span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <!-- 自動完成任務設定 -->
                            <a-form-item label="達成即完成">
                                <a-select
                                    v-model:value="formData.auto_complete"
                                    style="width: 100%"
                                >
                                    <a-select-option :value="true">
                                        是
                                    </a-select-option>
                                    <a-select-option :value="false">
                                        否
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item>
                                <div class="rules-section">
                                    <div class="rules-header">
                                        <a-button
                                            v-if="
                                                !formData.conditions ||
                                                formData.conditions.length === 0
                                            "
                                            type="dashed"
                                            @click="addCondition"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增條件
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.conditions &&
                                            formData.conditions.length > 0
                                        "
                                        class="rules-list"
                                    >
                                        <div
                                            v-for="(
                                                condition, index
                                            ) in formData.conditions"
                                            :key="index"
                                            class="rule-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="6">
                                                    <a-select
                                                        v-model:value="
                                                            condition.type
                                                        "
                                                        placeholder="選擇條件類型"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            () =>
                                                                handleConditionTypeChange(
                                                                    index
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="conditionType in getAvailableConditionTypes()"
                                                            :key="
                                                                conditionType.type
                                                            "
                                                            :value="
                                                                conditionType.type
                                                            "
                                                        >
                                                            {{
                                                                conditionType.label
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col
                                                    v-if="
                                                        condition.type &&
                                                        getConditionRequiredFields(
                                                            condition.type
                                                        ).code &&
                                                        condition.type !==
                                                            'node_complete'
                                                    "
                                                    :span="7"
                                                >
                                                    <!-- 表單/購買類型：顯示選單或輸入 -->
                                                    <a-select
                                                        v-if="
                                                            (
                                                                getConditionTypeOptions(
                                                                    condition.type
                                                                ) || []
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            condition.code
                                                        "
                                                        :placeholder="
                                                            getConditionCodePlaceholder(
                                                                condition.type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                        show-search
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        :filter-option="
                                                            filterOption
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in getConditionTypeOptions(
                                                                condition.type
                                                            )"
                                                            :key="
                                                                option.id ||
                                                                option.code
                                                            "
                                                            :value="
                                                                option.id
                                                                    ? `${condition.type}_${option.id}`
                                                                    : option.code
                                                            "
                                                        >
                                                            {{
                                                                option.name ||
                                                                option.label
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <a-input
                                                        v-else
                                                        v-model:value="
                                                            condition.code
                                                        "
                                                        :placeholder="
                                                            getConditionCodePlaceholder(
                                                                condition.type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col
                                                    v-else-if="
                                                        condition.type ===
                                                        'node_complete'
                                                    "
                                                    :span="7"
                                                >
                                                    <a-button
                                                        type="dashed"
                                                        @click="
                                                            () => {
                                                                console.log(
                                                                    '[StepEditModal] open-condition-node-selector clicked',
                                                                    {
                                                                        index,
                                                                        condition
                                                                    }
                                                                );
                                                                $emit(
                                                                    'open-condition-node-selector',
                                                                    index,
                                                                    condition
                                                                );
                                                            }
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        {{
                                                            getNodeSelectorLabel(
                                                                condition
                                                            ) || '選擇任務節點'
                                                        }}
                                                    </a-button>
                                                </a-col>
                                                <a-col
                                                    v-if="
                                                        condition.type &&
                                                        getConditionRequiredFields(
                                                            condition.type
                                                        ).operator
                                                    "
                                                    :span="3"
                                                >
                                                    <a-select
                                                        v-model:value="
                                                            condition.operator
                                                        "
                                                        placeholder="運算符"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                    >
                                                        <a-select-option
                                                            value="equals"
                                                        >
                                                            等於
                                                        </a-select-option>
                                                        <a-select-option
                                                            value="not_equals"
                                                        >
                                                            不等於
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col
                                                    v-if="
                                                        condition.type &&
                                                        getConditionRequiredFields(
                                                            condition.type
                                                        ).required_value
                                                    "
                                                    :span="5"
                                                >
                                                    <a-input
                                                        v-model:value="
                                                            condition.required_value
                                                        "
                                                        placeholder="要求值"
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col :span="3">
                                                    <a-form-item
                                                        style="margin-bottom: 0"
                                                    >
                                                        <a-checkbox
                                                            v-model:checked="
                                                                condition.require_review
                                                            "
                                                        >
                                                            需審核
                                                        </a-checkbox>
                                                    </a-form-item>
                                                </a-col>
                                                <a-col :span="2">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeCondition(
                                                                index
                                                            )
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                            <!-- URL 欄位：只在特定條件類型時顯示 -->
                                            <a-row
                                                v-if="
                                                    condition.type &&
                                                    needsUrl(condition.type)
                                                "
                                                :gutter="16"
                                                style="margin-top: 8px"
                                            >
                                                <a-col :span="24">
                                                    <a-form-item
                                                        label="跳轉網址（選填）"
                                                        style="margin-bottom: 0"
                                                    >
                                                        <a-input
                                                            v-model:value="
                                                                condition.redirect_url
                                                            "
                                                            placeholder="請輸入跳轉網址"
                                                            style="width: 100%"
                                                        />
                                                    </a-form-item>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rules">
                                        <a-empty
                                            description="尚未設定條件"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 獎勵設定區塊 -->
                    <a-collapse-panel key="rewards" class="form-section-panel">
                        <template #header>
                            <span class="section-header">獎勵設定</span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rewards-section">
                                    <div class="rewards-header">
                                        <a-button
                                            type="dashed"
                                            @click="addReward"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增獎勵
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.rewards &&
                                            formData.rewards.length > 0
                                        "
                                        class="rewards-list"
                                    >
                                        <div
                                            v-for="(
                                                reward, index
                                            ) in formData.rewards"
                                            :key="index"
                                            class="reward-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="8">
                                                    <a-select
                                                        v-model:value="
                                                            reward.reference_id
                                                        "
                                                        placeholder="選擇獎勵類型"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            (value) =>
                                                                handleRewardTypeChange(
                                                                    index,
                                                                    value
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.rewardTypes"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <a-input-number
                                                        v-model:value="
                                                            reward.value
                                                        "
                                                        placeholder="獎勵數量"
                                                        style="width: 100%"
                                                        :min="0"
                                                    />
                                                </a-col>
                                                <a-col :span="4">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeReward(index)
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rewards">
                                        <a-empty
                                            description="尚未設定獎勵"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>
                </a-collapse>
            </a-form>
        </template>
    </EditModal>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick } from 'vue';
import { message } from 'ant-design-vue';
import { showErrorMessage } from '@/utils/messageHelper';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import EditModal from '@/components/common/EditModal.vue';
import { getStepDetail, createStep, updateStep } from '@/api/missions';
import { searchUsers } from '@/api/users';
import { handleHttpError } from '@/api/errorHandler';
import dayjs from 'dayjs';
import { applyStartOfDay, applyEndOfDay } from '@/utils/dateTimePicker';
import { processSubmitData } from './missionFormUtils';

// Props
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    editingId: {
        type: Number,
        default: null
    },
    taskId: {
        type: Number,
        required: true
    },
    missionOptions: {
        type: Object,
        required: true
    },
    confirmLoading: {
        type: Boolean,
        default: false
    },
    nodeNameMap: {
        type: Object,
        default: () => ({})
    },
    unlockFromNodeLabel: {
        type: String,
        default: ''
    },
    triggeredByNodeLabel: {
        type: String,
        default: ''
    }
});

// Emits
const emit = defineEmits([
    'update:modelValue',
    'update:editingId',
    'success',
    'open-node-selector',
    'open-condition-node-selector'
]);

// Refs
const formRef = ref(null);
const sectionsActiveKeys = ref([
    'basic',
    'visibility',
    'executable',
    'conditions',
    'rewards'
]);

// Form data
const formData = reactive({
    task_id: props.taskId,
    name: '',
    description: '',
    attribute: undefined,
    is_active: true,
    is_repeatable: false,
    repeat_cycle: undefined,
    max_times_per_cycle: undefined,
    unlock_from_node_id: undefined,
    unlock_from_node_name: undefined, // 保存解鎖來源節點的名稱
    start_time: undefined,
    end_time: undefined,
    is_required: false,
    is_trigger: false,
    triggered_by_id: undefined,
    trigger_node_ids: [],
    trigger_node_names: {}, // 保存觸發節點 ID 到名稱的映射
    designated_collaborator: [],
    pass_through: false,
    auto_complete: true,
    redirect_url: undefined,
    rewards: [],
    conditions: [],
    visibility_rules: [],
    executable_rules: []
});

// 統一轉換 pass_through 為 boolean
const toBool = (v) => v === true || v === 1 || v === '1' || v === 'true';

// Form rules
const formRules = {
    name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
    attribute: [{ required: true, message: '請選擇屬性', trigger: 'change' }],
    task_id: [{ required: true, message: '請選擇任務', trigger: 'change' }],
    max_times_per_cycle: [
        {
            validator: async () => {
                // 如果有設置重複週期，最大重複次數必須至少為 1
                if (
                    formData.repeat_cycle &&
                    (!formData.max_times_per_cycle ||
                        formData.max_times_per_cycle < 1)
                ) {
                    return Promise.reject(
                        new Error('有設置重複週期時，最大重複次數至少為 1')
                    );
                }
                return Promise.resolve();
            },
            trigger: ['change', 'blur']
        }
    ],
    pass_through: [
        {
            validator: async () => {
                const isPassThrough = toBool(formData.pass_through);

                if (!isPassThrough) {
                    return Promise.resolve();
                }

                const conditions = Array.isArray(formData.conditions)
                    ? formData.conditions
                    : [];

                // 至少要有一個 node_complete 且 node_id 有值
                const hasValidNodeCondition = conditions.some(
                    (c) =>
                        c?.type === 'node_complete' &&
                        c.node_id != null &&
                        c.node_id !== undefined
                );

                if (!hasValidNodeCondition) {
                    return Promise.reject(
                        new Error(
                            '過期失效為「是」時，必須設定至少一個「任務節點」條件'
                        )
                    );
                }

                // 檢查是否有非 node_complete 類型的條件
                const hasInvalidCondition = conditions.some(
                    (c) => c?.type && c.type !== 'node_complete'
                );

                if (hasInvalidCondition) {
                    const invalidTypes = conditions
                        .filter((c) => c?.type && c.type !== 'node_complete')
                        .map((c) => c.type)
                        .join('、');
                    return Promise.reject(
                        new Error(
                            `過期失效為「是」時，任務條件必須是「任務節點」類型，但發現：${invalidTypes}`
                        )
                    );
                }

                return Promise.resolve();
            },
            trigger: ['change', 'blur']
        }
    ]
};

// 用戶搜尋相關
const userSearchState = reactive({
    visibility: {},
    executable: {}
});

const userSearchLoading = reactive({
    visibility: {},
    executable: {}
});

// Computed
const isVisible = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
});

const editingStepId = computed({
    get: () => props.editingId,
    set: (val) => emit('update:editingId', val)
});

// 檢查是否有 form/api 類型的條件
const hasFormOrApiCondition = computed(() => {
    return (
        formData.conditions &&
        formData.conditions.some(
            (condition) =>
                condition.type &&
                (condition.type.includes('form') ||
                    condition.type.includes('api'))
        )
    );
});

// 節點名稱
const getNodeName = (nodeId) => {
    return props.nodeNameMap[nodeId] || '';
};

// 規則處理
const addVisibilityRule = () => {
    formData.visibility_rules.push({
        audience_type: undefined,
        audience_ref: []
    });
};

const removeVisibilityRule = (index) => {
    formData.visibility_rules.splice(index, 1);
};

const addExecutableRule = () => {
    formData.executable_rules.push({
        actor_type: undefined,
        actor_ref: []
    });
};

const removeExecutableRule = (index) => {
    formData.executable_rules.splice(index, 1);
};

const handleRuleTypeChange = (ruleType, index) => {
    if (ruleType === 'visibility') {
        formData.visibility_rules[index].audience_ref = [];
    } else {
        formData.executable_rules[index].actor_ref = [];
    }
};

// 獎勵處理
const addReward = () => {
    formData.rewards.push({
        reward_type: 'point',
        reference_id: undefined,
        value: undefined
    });
};

const removeReward = (index) => {
    formData.rewards.splice(index, 1);
};

const handleRewardTypeChange = (index, value) => {
    const reward = formData.rewards[index];
    if (value === 'exp') {
        reward.reward_type = 'exp';
        reward.reference_id = undefined;
    } else {
        reward.reward_type = 'point';
        reward.reference_id = value;
    }
};

// 條件處理
const addCondition = () => {
    formData.conditions.push({
        type: undefined,
        code: undefined,
        operator: undefined,
        required_value: undefined,
        require_review: false,
        redirect_url: undefined,
        node_id: undefined,
        node_name: undefined
    });
    // 觸發 pass_through 驗證
    nextTick(() => {
        formRef.value?.validateFields(['pass_through']);
    });
};

const removeCondition = (index) => {
    formData.conditions.splice(index, 1);
    // 觸發 pass_through 驗證
    nextTick(() => {
        formRef.value?.validateFields(['pass_through']);
    });
};

const handleConditionTypeChange = (index) => {
    const condition = formData.conditions[index];

    // 如果過期失效是「是」，則條件類型必須是任務節點
    if (
        toBool(formData.pass_through) &&
        condition.type &&
        condition.type !== 'node_complete'
    ) {
        showErrorMessage('過期失效為「是」時，任務條件必須是「任務節點」類型');
        // 重置為任務節點類型
        condition.type = 'node_complete';
        condition.code = undefined;
        condition.operator = undefined;
        condition.required_value = undefined;
        // 觸發驗證
        nextTick(() => {
            formRef.value?.validateFields(['pass_through']);
        });
        return;
    }

    const requiredFields = getConditionRequiredFields(condition.type);

    // 觸發 pass_through 驗證（條件類型改變時）
    nextTick(() => {
        formRef.value?.validateFields(['pass_through']);
    });

    // 如果條件類型改變，重置 code（避免從 form 切換到 quiz_pass 時 code 還是 form_1）
    if (condition.code && condition.type) {
        // 檢查 code 的前綴是否與新類型匹配
        const codePrefix = condition.code.split('_')[0];
        const typePrefix = condition.type.split('_')[0];

        // 如果 code 的前綴與類型前綴不匹配，則重置 code
        // 例如：code 是 form_1，類型是 quiz_pass，則 form !== quiz，需要重置
        if (codePrefix !== typePrefix && codePrefix !== condition.type) {
            condition.code = undefined;
        }
    }

    if (!requiredFields.code) {
        condition.code = undefined;
    }
    if (!requiredFields.operator) {
        condition.operator = undefined;
    }
    if (!requiredFields.required_value) {
        condition.required_value = undefined;
    }
};

const getConditionRequiredFields = (type) => {
    if (!type) {
        return {
            code: false,
            operator: false,
            required_value: false
        };
    }
    // 從 conditionTypes 中找到對應類型的 required_fields
    const conditionType = props.missionOptions.conditionTypes?.find(
        (ct) => ct.type === type
    );
    return (
        conditionType?.required_fields || {
            code: false,
            operator: false,
            required_value: false
        }
    );
};

// 取得可用的條件類型（如果過期失效是「是」，只返回任務節點類型）
const getAvailableConditionTypes = () => {
    if (toBool(formData.pass_through)) {
        // 只返回任務節點類型
        return (
            props.missionOptions.conditionTypes?.filter(
                (ct) => ct.type === 'node_complete'
            ) || []
        );
    }
    // 否則返回所有類型
    return props.missionOptions.conditionTypes || [];
};

const getConditionTypeOptions = (type) => {
    if (!type) return [];
    // 從 conditionTypes 中找到對應類型的 options
    const conditionType = props.missionOptions.conditionTypes?.find(
        (ct) => ct.type === type
    );
    const options = conditionType?.options || [];
    return options;
};

const getConditionCodePlaceholder = (type) => {
    if (!type) return '請輸入';
    // 從 conditionTypes 中找到對應類型的 code_format
    const conditionType = props.missionOptions.conditionTypes?.find(
        (ct) => ct.type === type
    );
    if (conditionType?.code_format) {
        return conditionType.code_format;
    }
    // 如果有 options，顯示選擇提示
    if (conditionType?.options && conditionType.options.length > 0) {
        return '選擇' + (conditionType.label || '項目');
    }
    return '請輸入';
};

// 判斷條件類型是否需要 URL
const needsUrl = (conditionType) => {
    return (
        conditionType === 'form' ||
        conditionType === 'api_verify' ||
        conditionType === 'ack'
    );
};

const getNodeSelectorLabel = (condition) => {
    // 優先使用保存的節點名稱
    if (condition.node_name) {
        return condition.node_name;
    }
    // 其次從 nodeNameMap 查找
    if (condition.node_id && props.nodeNameMap[condition.node_id]) {
        return props.nodeNameMap[condition.node_id];
    }
    // 如果都沒有，嘗試從 code 解析 node_id 並查找
    if (condition.code && !condition.node_id) {
        const parts = condition.code.split('_');
        if (parts.length >= 2) {
            const nodeId = Number(parts.slice(1).join('_'));
            if (nodeId && props.nodeNameMap[nodeId]) {
                return props.nodeNameMap[nodeId];
            }
        }
    }
    return '';
};

const filterOption = (input, option) => {
    const label = option.children?.[0]?.children || option.label || '';
    return label.toLowerCase().includes(input.toLowerCase());
};

// 用戶搜尋
const getUserSearchOptions = (type, index) => {
    return userSearchState[type]?.[index] || [];
};

const getUserSearchLoading = (type, index) => {
    return userSearchLoading[type]?.[index] || false;
};

const handleUserSearch = async (type, index, keyword) => {
    if (!keyword || keyword.trim() === '') {
        userSearchState[type][index] = [];
        return;
    }

    try {
        userSearchLoading[type][index] = true;
        const response = await searchUsers({ name: keyword.trim() });
        userSearchState[type][index] = response.data.map((user) => ({
            label: user.name || user.username,
            value: user.id
        }));
    } catch (error) {
        handleHttpError(error, '搜尋會員');
    } finally {
        userSearchLoading[type][index] = false;
    }
};

// 規則選項相關函數
const getVisibilityTypeOptions = (audienceType) => {
    if (!audienceType) return [];
    // 從 visibility_audience_types 中找到對應類型的 options
    const typeConfig = props.missionOptions.visibility_audience_types?.find(
        (type) => type.value === audienceType
    );
    return typeConfig?.options || [];
};

const getExecutableTypeOptions = (actorType) => {
    if (!actorType) return [];
    // 從 executable_actor_types 中找到對應類型的 options
    const typeConfig = props.missionOptions.executable_actor_types?.find(
        (type) => type.value === actorType
    );
    return typeConfig?.options || [];
};

const getVisibilityPlaceholder = (audienceType) => {
    const placeholders = {
        role: '選擇角色',
        department: '選擇事業部',
        rank: '選擇聘階',
        user: '搜尋會員'
    };
    return placeholders[audienceType] || '請選擇';
};

const getExecutablePlaceholder = (actorType) => {
    const placeholders = {
        role: '選擇角色',
        department: '選擇事業部',
        rank: '選擇聘階',
        user: '搜尋會員'
    };
    return placeholders[actorType] || '請選擇';
};

const getVisibilityInputPlaceholder = (audienceType) => {
    return '請輸入';
};

const getExecutableInputPlaceholder = (actorType) => {
    return '請輸入';
};

// 重置表單
const resetForm = () => {
    formData.task_id = props.taskId;
    formData.name = '';
    formData.description = '';
    formData.attribute = undefined;
    formData.is_active = true;
    formData.is_repeatable = false;
    formData.repeat_cycle = undefined;
    formData.max_times_per_cycle = undefined;
    formData.unlock_from_node_id = undefined;
    formData.unlock_from_node_name = undefined;
    formData.start_time = undefined;
    formData.end_time = undefined;
    formData.is_required = false;
    formData.is_trigger = false;
    formData.triggered_by_id = undefined;
    formData.trigger_node_ids = [];
    formData.trigger_node_names = {};
    formData.designated_collaborator = [];
    formData.pass_through = false;
    formData.auto_complete = true;
    formData.rewards = [];
    formData.conditions = [];
    formData.visibility_rules = [];
    formData.executable_rules = [];

    // 重置用戶搜尋狀態
    userSearchState.visibility = {};
    userSearchState.executable = {};
    userSearchLoading.visibility = {};
    userSearchLoading.executable = {};

    nextTick(() => {
        formRef.value?.clearValidate();
    });
};

// 載入資料
const loadData = async (id) => {
    try {
        const response = await getStepDetail(id);
        const data = response.data;

        formData.task_id = data.task_id;
        formData.name = data.name;
        formData.description = data.description || '';
        formData.attribute = data.attribute;
        formData.is_active = data.is_active;
        formData.is_repeatable = data.is_repeatable || false;
        formData.repeat_cycle = data.repeat_cycle;
        formData.max_times_per_cycle = data.max_times_per_cycle;
        formData.unlock_from_node_id = data.unlock_from_node_id;
        // 保存解鎖來源節點的名稱（用於顯示）
        formData.unlock_from_node_name = data.unlock_from_node?.name || null;
        formData.start_time = data.start_time
            ? dayjs(data.start_time)
            : undefined;
        formData.end_time = data.end_time ? dayjs(data.end_time) : undefined;
        formData.is_required = data.is_required || false;
        formData.is_trigger = data.is_trigger || false;
        formData.triggered_by_id = data.triggered_by_id;
        formData.trigger_node_ids = data.trigger_node_ids || [];
        // 保存觸發節點的名稱映射（用於顯示）
        formData.trigger_node_names = {};
        if (data.trigger_nodes && Array.isArray(data.trigger_nodes)) {
            data.trigger_nodes.forEach((node) => {
                if (node.id && node.name) {
                    formData.trigger_node_names[node.id] = node.name;
                }
            });
        }
        // 處理 designated_collaborator：支援單值或陣列
        if (data.designated_collaborator) {
            formData.designated_collaborator = Array.isArray(
                data.designated_collaborator
            )
                ? data.designated_collaborator
                : [data.designated_collaborator];
        } else {
            formData.designated_collaborator = [];
        }
        // 標準化 pass_through 為 boolean
        formData.pass_through = toBool(data.pass_through);
        formData.auto_complete =
            data.auto_complete !== undefined ? data.auto_complete : true;
        formData.redirect_url = data.redirect_url || undefined;

        // 處理可見性規則
        formData.visibility_rules =
            data.visibility_rules?.map((rule, ruleIndex) => {
                let audienceRef = [];
                if (rule.audience_ref) {
                    const refArray = Array.isArray(rule.audience_ref)
                        ? rule.audience_ref
                        : rule.audience_ref.split(',');

                    // 處理名稱字串（可能包含多個名稱，用逗號分隔）
                    const names = rule.audience_name
                        ? rule.audience_name.split(',').map((n) => n.trim())
                        : [];

                    // 根據 audience_type 找到對應的選項
                    const typeConfig =
                        props.missionOptions.visibility_audience_types?.find(
                            (type) => type.value === rule.audience_type
                        );
                    const options = typeConfig?.options || [];

                    if (options.length > 0) {
                        // 根據選項的 value 類型來轉換
                        audienceRef = refArray.map((ref) => {
                            // 嘗試在選項中找到匹配的項目
                            const matchedOption = options.find((opt) => {
                                const optValue =
                                    opt.id || opt.code || opt.value || opt.name;
                                return String(optValue) === String(ref);
                            });

                            if (matchedOption) {
                                return (
                                    matchedOption.id ||
                                    matchedOption.code ||
                                    matchedOption.value ||
                                    matchedOption.name
                                );
                            }
                            return ref;
                        });
                    } else if (rule.audience_type === 'user') {
                        // 對於 user 類型，需要將名稱加入到搜尋選項中
                        audienceRef = refArray.map((ref, refIndex) => {
                            const name = names[refIndex] || ref;

                            // 初始化搜尋選項
                            if (!userSearchState.visibility[ruleIndex]) {
                                userSearchState.visibility[ruleIndex] = [];
                            }

                            // 如果選項中還沒有這個 ID，則加入
                            const existingOption = userSearchState.visibility[
                                ruleIndex
                            ].find((opt) => opt.value === ref);
                            if (!existingOption) {
                                userSearchState.visibility[ruleIndex].push({
                                    label: name,
                                    value: ref
                                });
                            } else {
                                // 更新現有選項的 label
                                existingOption.label = name;
                            }

                            return ref;
                        });
                    } else {
                        // 對於其他類型，保持原始值
                        audienceRef = refArray;
                    }
                }

                return {
                    audience_type: rule.audience_type,
                    audience_ref: audienceRef
                };
            }) || [];

        // 處理可執行規則
        formData.executable_rules =
            data.executable_rules?.map((rule, ruleIndex) => {
                let actorRef = [];
                if (rule.actor_ref) {
                    const refArray = Array.isArray(rule.actor_ref)
                        ? rule.actor_ref
                        : rule.actor_ref.split(',');

                    // 處理名稱字串（可能包含多個名稱，用逗號分隔）
                    const names = rule.actor_name
                        ? rule.actor_name.split(',').map((n) => n.trim())
                        : [];

                    // 根據 actor_type 找到對應的選項，確保值類型匹配
                    const typeConfig =
                        props.missionOptions.executable_actor_types?.find(
                            (type) => type.value === rule.actor_type
                        );
                    const options = typeConfig?.options || [];

                    if (options.length > 0) {
                        // 根據選項的 value 類型來轉換，確保能正確匹配
                        actorRef = refArray.map((ref) => {
                            // 嘗試在選項中找到匹配的項目
                            const matchedOption = options.find((opt) => {
                                const optValue =
                                    opt.id || opt.code || opt.value || opt.name;
                                return String(optValue) === String(ref);
                            });

                            if (matchedOption) {
                                // 返回選項的實際 value（用於綁定）
                                return (
                                    matchedOption.id ||
                                    matchedOption.code ||
                                    matchedOption.value ||
                                    matchedOption.name
                                );
                            }

                            // 如果找不到匹配，保持原始值
                            return ref;
                        });
                    } else if (rule.actor_type === 'user') {
                        // 對於 user 類型，需要將名稱加入到搜尋選項中
                        actorRef = refArray.map((ref, refIndex) => {
                            const name = names[refIndex] || ref;

                            // 初始化搜尋選項
                            if (!userSearchState.executable[ruleIndex]) {
                                userSearchState.executable[ruleIndex] = [];
                            }

                            // 如果選項中還沒有這個 ID，則加入
                            const existingOption = userSearchState.executable[
                                ruleIndex
                            ].find((opt) => opt.value === ref);
                            if (!existingOption) {
                                userSearchState.executable[ruleIndex].push({
                                    label: name,
                                    value: ref
                                });
                            } else {
                                // 更新現有選項的 label
                                existingOption.label = name;
                            }

                            return ref;
                        });
                    } else {
                        // 如果沒有選項，保持原始值
                        actorRef = refArray;
                    }
                }

                return {
                    actor_type: rule.actor_type,
                    actor_ref: actorRef
                };
            }) || [];

        // 處理條件
        formData.conditions =
            data.conditions?.map((condition) => {
                // 如果沒有 node_id 但有 code，從 code 解析出 node_id
                let nodeId = condition.node_id;
                if (!nodeId && condition.code) {
                    const parts = condition.code.split('_');
                    if (parts.length >= 2) {
                        nodeId = Number(parts.slice(1).join('_'));
                    }
                }
                return {
                    type: condition.type,
                    code: condition.code,
                    operator: condition.operator,
                    required_value: condition.required_value,
                    require_review: condition.require_review || false,
                    node_id: nodeId,
                    redirect_url: undefined, // 不從條件中載入，改為從任務層級載入
                    // 保存 API 返回的 code_name 作為 node_name（用於顯示）
                    node_name: condition.code_name || null
                };
            }) || [];

        // 將任務層級的 redirect_url 回填到第一個需要 URL 的條件中
        if (data.redirect_url) {
            const firstConditionNeedingUrl = formData.conditions.find(
                (condition) => condition.type && needsUrl(condition.type)
            );
            if (firstConditionNeedingUrl) {
                firstConditionNeedingUrl.redirect_url = data.redirect_url;
            }
        }

        // 處理獎勵
        formData.rewards =
            data.rewards?.map((reward) => {
                // 如果是經驗值獎勵，reference_id 應該是 'exp'
                if (reward.reward_type === 'exp') {
                    return {
                        reward_type: 'exp',
                        reference_id: 'exp',
                        value: reward.value
                    };
                }
                return {
                    reward_type: reward.reward_type || 'point',
                    reference_id: reward.reference_id,
                    value: reward.value
                };
            }) || [];

        // 如果有資料，則預設展開該區塊
        if (formData.visibility_rules.length > 0) {
            if (!sectionsActiveKeys.value.includes('visibility')) {
                sectionsActiveKeys.value.push('visibility');
            }
        }
        if (formData.executable_rules.length > 0) {
            if (!sectionsActiveKeys.value.includes('executable')) {
                sectionsActiveKeys.value.push('executable');
            }
        }
        if (formData.conditions.length > 0) {
            if (!sectionsActiveKeys.value.includes('conditions')) {
                sectionsActiveKeys.value.push('conditions');
            }
        }
        if (formData.rewards.length > 0) {
            if (!sectionsActiveKeys.value.includes('rewards')) {
                sectionsActiveKeys.value.push('rewards');
            }
        }

        nextTick(() => {
            formRef.value?.clearValidate();
        });
    } catch (error) {
        handleHttpError(error, '載入步驟資料');
        showErrorMessage('載入步驟資料失敗');
    }
};

// 提交
const handleSubmit = async () => {
    try {
        // Ant Form 驗證（包含 pass_through 的自訂 validator）
        await formRef.value.validate();

        // 統一處理提交資料格式
        const submitData = processSubmitData(formData, {
            fields: [
                'task_id',
                'name',
                'description',
                'attribute',
                'is_active',
                'is_repeatable',
                'repeat_cycle',
                'max_times_per_cycle',
                'unlock_from_node_id',
                'start_time',
                'end_time',
                'is_required',
                'is_trigger',
                'triggered_by_id',
                'trigger_node_ids',
                'designated_collaborator',
                'pass_through',
                'auto_complete',
                'redirect_url',
                'rewards',
                'visibility_rules',
                'executable_rules',
                'conditions'
            ],
            fieldDefaults: {
                unlock_from_node_id: null,
                triggered_by_id: null,
                redirect_url: null
            },
            deleteEmptyTime: true,
            processConditions: true
        });

        // 從條件中提取 redirect_url 到任務層級（取第一個有 URL 的條件）
        const conditionWithUrl = formData.conditions.find(
            (condition) =>
                condition.type &&
                needsUrl(condition.type) &&
                condition.redirect_url
        );
        if (conditionWithUrl && conditionWithUrl.redirect_url) {
            submitData.redirect_url = conditionWithUrl.redirect_url;
        }

        // 最後一次驗證：使用最終要送出的 submitData 檢查（避免 processSubmitData 洗掉資料）
        const isPassThrough = toBool(submitData.pass_through);
        if (isPassThrough) {
            const submitConditions = Array.isArray(submitData.conditions)
                ? submitData.conditions
                : [];

            if (submitConditions.length === 0) {
                showErrorMessage(
                    '過期失效為「是」時，必須設定至少一個任務條件，且條件類型必須為「任務節點」'
                );
                return;
            }

            // 檢查是否有非 node_complete 類型的條件
            const hasInvalidCondition = submitConditions.some(
                (c) => c && c.type && c.type !== 'node_complete'
            );
            if (hasInvalidCondition) {
                const invalidTypes = submitConditions
                    .filter((c) => c && c.type && c.type !== 'node_complete')
                    .map((c) => c.type)
                    .join('、');
                showErrorMessage(
                    `過期失效為「是」時，任務條件必須是「任務節點」類型，但發現：${invalidTypes}`
                );
                return;
            }

            // 檢查是否有至少一個有效的任務節點條件（必須有 node_id）
            const hasValidNodeCondition = submitConditions.some(
                (c) =>
                    c &&
                    c.type === 'node_complete' &&
                    c.node_id != null &&
                    c.node_id !== undefined
            );
            if (!hasValidNodeCondition) {
                showErrorMessage(
                    '過期失效為「是」時，必須設定至少一個有效的任務節點條件（請選擇任務節點）'
                );
                return;
            }
        }

        if (editingStepId.value) {
            await updateStep(editingStepId.value, submitData);
            message.success('更新步驟成功');
        } else {
            await createStep(submitData);
            message.success('新增步驟成功');
        }

        isVisible.value = false;
        emit('success');
    } catch (error) {
        if (error.errorFields) {
            showErrorMessage('請填寫必填欄位');
            return;
        }
        handleHttpError(error, editingStepId.value ? '更新步驟' : '新增步驟');
        showErrorMessage(editingStepId.value ? '更新步驟失敗' : '新增步驟失敗');
    }
};

// 取消
const handleCancel = () => {
    resetForm();
    isVisible.value = false;
};

// Watch
// 監聽 editingId 變化（只在視窗關閉時重置表單，避免重複呼叫）
watch(
    () => props.editingId,
    (newId) => {
        if (!newId && !isVisible.value) {
            resetForm();
        }
    }
);

// 監聽 isVisible 變化（只在這裡載入資料，避免重複呼叫）
watch(isVisible, (newVal) => {
    if (newVal) {
        if (props.editingId) {
            loadData(props.editingId);
        } else {
            resetForm();
        }
    } else {
        resetForm();
    }
});

watch(
    () => props.taskId,
    (newId) => {
        formData.task_id = newId;
    }
);

// 監聽 pass_through 變化，如果改為「是」，檢查並處理條件
watch(
    () => formData.pass_through,
    (newVal) => {
        if (toBool(newVal)) {
            // 如果過期失效改為「是」，檢查現有條件
            if (formData.conditions && formData.conditions.length > 0) {
                // 檢查是否有非任務節點類型的條件
                const nonNodeConditions = formData.conditions.filter(
                    (condition) =>
                        condition.type && condition.type !== 'node_complete'
                );

                if (nonNodeConditions.length > 0) {
                    // 移除非任務節點類型的條件
                    formData.conditions = formData.conditions.filter(
                        (condition) =>
                            !condition.type ||
                            condition.type === 'node_complete'
                    );
                    showErrorMessage(
                        '過期失效為「是」時，任務條件必須是「任務節點」類型，已自動移除其他類型的條件'
                    );
                }

                // 如果沒有任務節點條件，提示需要添加
                const hasNodeCondition = formData.conditions.some(
                    (condition) => condition.type === 'node_complete'
                );
                if (!hasNodeCondition) {
                    message.warning(
                        '過期失效為「是」時，必須設定至少一個「任務節點」類型的條件'
                    );
                }
            } else {
                // 如果沒有條件，提示需要添加任務節點條件
                message.warning(
                    '過期失效為「是」時，必須設定至少一個「任務節點」類型的條件'
                );
            }
        }
    }
);

// 監聽重複週期變化，觸發最大次數驗證
watch(
    () => formData.repeat_cycle,
    () => {
        if (formRef.value) {
            nextTick(() => {
                formRef.value.validateFields(['max_times_per_cycle']);
            });
        }
    }
);

// 監聽 conditions 變化，觸發 pass_through 驗證
watch(
    () => formData.conditions,
    () => {
        if (toBool(formData.pass_through)) {
            nextTick(() => {
                formRef.value?.validateFields(['pass_through']);
            });
        }
    },
    { deep: true }
);
</script>

<style scoped>
/* 表單區塊摺疊面板樣式 */
.form-sections-collapse {
    background: transparent !important;
    border: none !important;
}

.form-sections-collapse :deep(.ant-collapse-item) {
    background: transparent !important;
    border: none !important;
    margin-bottom: 8px !important;
}

.form-sections-collapse :deep(.ant-collapse-header) {
    background: rgba(255, 255, 255, 0.95) !important;
    padding: 12px 16px !important;
    border: 1px solid rgba(42, 74, 122, 0.2) !important;
    border-radius: 12px !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1) !important;
    transition: all 0.3s ease !important;
}

.form-sections-collapse :deep(.ant-collapse-header:hover) {
    background: rgba(255, 255, 255, 1) !important;
    border-color: rgba(42, 74, 122, 0.4) !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.2) !important;
}

.form-sections-collapse :deep(.ant-collapse-content) {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
}

.form-sections-collapse :deep(.ant-collapse-content-box) {
    padding: 0 !important;
}

.form-section-card-inner {
    background: rgba(255, 255, 255, 0.95) !important;
    border: 1px solid rgba(42, 74, 122, 0.2) !important;
    border-radius: 0 0 12px 12px !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1) !important;
    margin-top: -8px !important;
    padding: 16px !important;
}

.section-header {
    font-family: 'Courier New', monospace;
    font-size: 14px;
    font-weight: 600;
    color: #2a4a7a;
}

.section-note {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-weight: normal;
}

/* 規則與獎勵樣式 */
.rules-section,
.rewards-section {
    width: 100%;
}

.rules-header,
.rewards-header {
    margin-bottom: 16px;
}

.rules-list,
.rewards-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.rule-item,
.reward-item {
    padding: 12px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(42, 74, 122, 0.15);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.rule-item:hover,
.reward-item:hover {
    border-color: rgba(42, 74, 122, 0.3);
    background: rgba(255, 255, 255, 0.7);
}

.delete-rule-btn {
    color: #ff4d4f;
}

/* 空狀態時減少 padding */
.form-section-card-inner:has(.no-rules) :deep(.ant-card-body),
.form-section-card-inner:has(.no-rewards) :deep(.ant-card-body) {
    padding: 4px 12px !important;
}

.no-rules,
.no-rewards {
    padding: 12px;
    text-align: center;
}

/* 隱藏空狀態的 image */
.no-rules :deep(.ant-empty-image),
.no-rewards :deep(.ant-empty-image) {
    display: none;
}

/* 節點選擇器樣式 */
.node-selector-display {
    padding: 8px 12px;
    background: rgba(42, 74, 122, 0.05);
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-height: 40px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.node-selector-display:hover {
    background: rgba(42, 74, 122, 0.1);
    border-color: rgba(42, 74, 122, 0.4);
}

.node-selector-display.multiple {
    padding: 4px 8px;
}

.node-tag {
    margin: 0 !important;
}

.node-selector-btn {
    width: 100%;
    border-color: rgba(42, 74, 122, 0.3);
    color: #2a4a7a;
}

.node-selector-btn:hover {
    border-color: #2a4a7a;
    color: #2a4a7a;
}

.form-row-compact {
    margin-bottom: 0;
}
</style>
